import localeData from '../helpers/login.lang'
import {loginModes, errorMessages} from '../helpers/login.data'
import {isModeOneOf} from '../login.helper'

const {
  createNewPassword,
  renewExpiredPassword,
  tfaCode,
  normal,
  forgotPasswordEmailSent,
  audit,
  newUserLinkExpired
} = loginModes
const {USER_PENALIZED} = errorMessages

const language = 'en'
const locale = localeData[language]

// event handlers
export const onKeyDownHandler = ({key, onSubmit}) => (key === 'Enter') && onSubmit()
export const onChangeHandler = ({target, onUpdate}) => onUpdate(target.value)

// input field labels
export const usernameLabel = locale.username()
export const passwordPlaceholder = ({mode}) => {
  if (mode === renewExpiredPassword) {
    return locale.renewPasswordPlaceholder()
  }
  if (mode === createNewPassword) {
    return locale.newPasswordPlaceholder()
  }
  return locale.passwordPlaceholder()
}

export const confirmPasswordPlaceholder = ({mode}) => ((mode === createNewPassword)
  ? locale.confirmPasswordPlaceholder()
  : locale.renewConfirmPasswordPlaceholder())

export const confirmPasswordLabel = locale.confirmPassword()
export const TFALabel = locale.secretCode()

// disabled checks
export const isUsernameDisabled = ({isAuthInProgress, mode, isPasswordPolicyPending}) => isPasswordPolicyPending || isAuthInProgress || isModeOneOf({mode, modes: [tfaCode, createNewPassword, renewExpiredPassword]})
export const arePasswordsDisabled = ({isAuthInProgress, isPasswordPolicyPending}) => isPasswordPolicyPending || isAuthInProgress
export const isTFADisabled = ({isAuthInProgress, codeSendMessage, isPasswordPolicyPending}) => isPasswordPolicyPending || isAuthInProgress || (codeSendMessage === USER_PENALIZED)

export const isAutofocus = ({mode, field}) => {
  if (field === 'username') {
    return !isModeOneOf({mode, modes: [forgotPasswordEmailSent, audit, newUserLinkExpired]})
  }
  if (field === 'password') {
    return isModeOneOf({mode, modes: [normal, createNewPassword, renewExpiredPassword]})
  }
  if (field === 'tfa') {
    return mode === tfaCode
  }
  return false
}
